import React from "react";
import DashboardSection from "../../Sections/Dashboard";
import Dashboard from "./Dashboard";

const DashboardComponent = () => {
    return <Dashboard sectionName={<DashboardSection />} />;
};

export default DashboardComponent;
